
export const FormButtonTypes = {
    success: { key: 'success', value: 'submit', style: 'primary' },
    danger: { key: 'danger', value: 'submit', style: 'danger' },
    cancel: { key: 'cancel', value: 'button', style: 'cancel' },
}

export class FormField {
    constructor(payload = { name: 'field', label: 'Untitled', placeholder: '', type: 'text', info: '' }) {
        this.value = payload.value;
        this.name = payload.name;
        this.label = payload.label;
        this.placeholder = payload.placeholder;
        this.type = payload.type;
        this.info = payload.info;
    }
}

export class FormButton {
    constructor(payload = { name: 'Submit', type: FormButtonTypes.success }) {
        this.name = payload.name;
        this.type = payload.type;
    }
}


export const createComponentForm = {
    title: 'Create Component',
    fields: [
        new FormField({ name: 'name', label: 'Component Name', placeholder: 'Component Name' })
    ],
    buttons: [
        new FormButton({ name: 'Cancel', type: FormButtonTypes.cancel }),
        new FormButton({ name: 'Create', type: FormButtonTypes.success }),
    ],
    values() {
        return this.fields
            .map((item) => ({ [item.name]: item.value }))
            .reduce((prev, curr) => ({ ...prev, ...curr }), {});
    }
} 